import { Card } from 'semantic-ui-react'
import { AppRemoveButtonPopup, AppEditButton, PaginationComponent } from 'components'
import React from 'react'
import { DesktopMode, MobileMode } from 'layout'
import styled from 'styled-components'

const Block = styled.div`
    margin-top: 8px;
`

const Heading = styled.h3`
    margin: 0 0 10px;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.02em;
    color: #1c1917;
`

const Frame = styled.div`
    background: #fff;
    border: 1px solid #e7e5e4;
    border-radius: 14px;
    overflow-x: auto;
`

const Grid = styled.table`
    width: 100%;
    min-width: 680px;
    border-collapse: collapse;
    table-layout: fixed;

    th {
        text-align: left;
        padding: 12px 14px;
        background: #fafaf9;
        color: #78716c;
        font-size: 12px;
        font-weight: 600;
        border-bottom: 1px solid #e7e5e4;
        white-space: nowrap;
    }

    td {
        padding: 10px 14px;
        border-bottom: 1px solid #f5f5f4;
        color: #1c1917;
        font-size: 14px;
        vertical-align: middle;
    }

    tr:last-child td {
        border-bottom: 0;
    }

    tbody tr:hover td {
        background: #fafaf9;
    }

    th:last-child,
    td:last-child {
        width: 112px;
        text-align: right;
        white-space: nowrap;
    }
`

const Clip = styled.span`
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

const Actions = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;

    .ui.button {
        margin: 0 !important;
        padding: 0.55em !important;
        min-width: 32px !important;
        width: 32px;
        height: 32px;
    }
`

const Empty = styled.div`
    padding: 28px 16px;
    text-align: center;
    color: #78716c;
    background: #fff;
    border: 1px solid #e7e5e4;
    border-radius: 14px;
`

const Pager = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
`

const shown = value => {
    const raw = value == null ? '' : String(value).trim()
    return raw || '—'
}

const addressOf = item =>
    [item?.AddressLine1, item?.AddressLine2].map(part => String(part || '').trim()).filter(Boolean).join(', ') || '—'

const CompanyCard = ({ item, remove, onEdit }) => (
    <Card fluid>
        <Card.Content>
            <Card.Header>{addressOf(item)}</Card.Header>
            <Card.Meta>
                {[item.City, item.State, item.Country].filter(Boolean).join(', ')}
                {item.Zipcode ? ` ${item.Zipcode}` : ''}
            </Card.Meta>
            <Actions className="mt-2">
                <AppEditButton onClick={() => onEdit(item)} type="button" />
                <AppRemoveButtonPopup onConfirm={() => remove(item.SettingId)} />
            </Actions>
        </Card.Content>
    </Card>
)

export const CompanyList = ({ data, filter, pageChanged, totalCount, remove, onEdit }) => {
    const rows = Array.isArray(data) ? data : []

    return (
        <Block>
            <Heading>Saved addresses</Heading>
            {rows.length === 0 ? (
                <Empty>No addresses yet.</Empty>
            ) : (
                <>
                    <DesktopMode>
                        <Frame>
                            <Grid>
                                <thead>
                                    <tr>
                                        <th>Address</th>
                                        <th>City</th>
                                        <th>State</th>
                                        <th>Country</th>
                                        <th>Zip code</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map(item => (
                                        <tr key={item.SettingId}>
                                            <td><Clip title={addressOf(item)}>{addressOf(item)}</Clip></td>
                                            <td><Clip>{shown(item.City)}</Clip></td>
                                            <td><Clip>{shown(item.State)}</Clip></td>
                                            <td><Clip>{shown(item.Country)}</Clip></td>
                                            <td><Clip>{shown(item.Zipcode)}</Clip></td>
                                            <td>
                                                <Actions>
                                                    <AppEditButton onClick={() => onEdit(item)} type="button" />
                                                    <AppRemoveButtonPopup onConfirm={() => remove(item.SettingId)} />
                                                </Actions>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Grid>
                        </Frame>
                    </DesktopMode>
                    <MobileMode>
                        {rows.map(item => (
                            <div key={item.SettingId} className="mb-3">
                                <CompanyCard item={item} remove={remove} onEdit={onEdit} />
                            </div>
                        ))}
                    </MobileMode>
                    <Pager>
                        <PaginationComponent
                            activePage={filter?.PageNumber}
                            pageChanged={pageChanged}
                            pageSize={filter?.PageSize}
                            totalCount={totalCount}
                        />
                    </Pager>
                </>
            )}
        </Block>
    )
}
